<template>
    <v-layout row wrap>
        <v-flex xs12>
            <v-card flat>
                <v-card-title class="primary modal-title" primary-title style="font-size: 14px !important">
                    <div class="de-info mr-4">
                        <p>
                            <strong>Processo:</strong> {{compraDiretaParcial.processo}}
                            <span v-if="compraDiretaParcial.quantidadeRepeticoes">
                                - <strong>Repetição:</strong> {{compraDiretaParcial.quantidadeRepeticoes}}
                            </span>
                        </p>
                        <p><strong>Situação:</strong> {{compraDiretaParcial.situacao | azEnum(situacoesCompraDireta)}}</p>
                    </div>
                    <div class="de-info mr-4">
                        <p><strong>Nome arquivo:</strong> {{documento.nome}}</p>
                    </div>
                    <div class="de-info">
                        <p v-if="documento.fornecedorId">
                            <strong>Fornecedor:</strong> {{documento.fornecedorNome}}
                        </p>
                        <p v-else>
                            <strong>Tipo documento:</strong> {{documento.descricaoTipo}}
                        </p>
                    </div>
                    <v-spacer></v-spacer>
                    <div class="de-info" style="font-size: 10px !important">
                        <v-icon size="12" class="mr-2" color="white">fas fa-sync</v-icon>
                        Salva automaticamente estado parcial a cada 15 segundos
                    </div>
                </v-card-title>

                <v-card-text>
                    <editor
                        id="editorDeTexto"
                        :api-key="tokenEditor"
                        :init="{
                            language: 'pt_BR',
                            height: 500,
                            autosave_interval: '15s',
                            autosave_retention: '180m',
                            autosave_prefix: autoSavePrefix,
                            autosave_restore_when_empty: true,
                            plugins: [
                              'a11ychecker', 'accordion', 'advlist', 'anchor', 'autolink', 'autosave',
                              'charmap', 'code', 'codesample', 'directionality', 'emoticons', 'exportpdf',
                              'exportword', 'fullscreen', 'help', 'image', 'importcss', 'importword',
                              'insertdatetime', 'link', 'lists', 'markdown', 'math', 'media', 'nonbreaking',
                              'pagebreak', 'preview', 'quickbars', 'save', 'searchreplace', 'table',
                              'visualblocks', 'visualchars', 'wordcount'
                            ],
                            toolbar:
                              'undo redo | accordion accordionremove | \
                              importword exportword exportpdf | math | \
                              blocks fontfamily fontsize | bold italic underline strikethrough | \
                              align numlist bullist | link | table | \
                              lineheight outdent indent | forecolor backcolor removeformat | \
                              charmap emoticons | code fullscreen preview | save print | \
                              pagebreak anchor codesample | ltr rtl | restoredraft',
                            menubar: 'file edit view insert format tools table help',
                            setup: (editor) => setUpEditor(editor)
                        }"
                        :initial-value="conteudoHtml"
                        model-events="change keydown blur focus paste keyup undo redo"
                        v-model="conteudoHtml"
                    />
                </v-card-text>
                <v-card-actions class="px-3 py-2">
                    <v-btn flat outline color="botao-cancelar-color" @click="content = ''">
                        <v-icon size="18" class="mr-2">fas fa-eraser</v-icon>
                        Limpar
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" depressed @click="salvar">
                        <v-icon size="18" class="mr-2">fas fa-save</v-icon>
                        Finalizar e Salvar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'

export default {
    name: 'TinyEditor',
    components: {
        'editor': Editor
    },
    props: {
        documento: {
            type: Object,
            required: true

        },
        compraDiretaParcial: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            conteudoHtml: ''
        }
    },
    computed: {
        autoSavePrefix(){
            return `compra-direta-${this.$route.params.id}
            -documento-${this.$route.params.documentoId}
            -${this.$route.params.tipoDocumento}-desentrahamento`
        },
        tokenEditor() {
            return this.$store.state.parametros.propriedadesCompraDiretas.tinyEditorKey
        },
    },
    methods: {
        salvar() {
            this.$emit('eventoDesentranhar', this.conteudoHtml, this.autoSavePrefix)
        },

        setUpEditor(editor) {
            editor.on('init', async () => {
                setTimeout(() => {
                    this.conteudoHtml = editor.getContent() || 'Seja bem vindo! Por favor, escreva seu texto aqui.'
                }, 1000)
            })
        }
    },
}
</script>

<style scoped>
@media (min-width: 1024px) {
    #editorDeTexto {
        display: flex;
        flex-direction: column;
        place-items: center;
        width: 1000px;
    }
}
</style>